import React from 'react';
import { useTranslation } from 'react-i18next';

import { Wrap, Label, Field, Input } from './BrandNameInput.styles';

export interface BrandNameInputProps {
  value: string;
  onChange: (value: string) => void;
  /** Placeholder copy (i18n key). */
  placeholder: string;
  /** Optional field label (i18n key) — shown on desktop, omitted on mobile. */
  label?: string;
}

/**
 * Underline brand-name field for the manual subflow ("I have my own name"). The
 * underline turns orange while focused or filled. Typing drives the debounced
 * domain lookup in the store.
 */
export const BrandNameInput = ({ value, onChange, placeholder, label }: BrandNameInputProps): React.ReactElement => {
  const { t } = useTranslation();
  const [focused, setFocused] = React.useState(false);
  const active = focused || value.length > 0;

  return (
    <Wrap>
      {label ? <Label text={label} tag="span" /> : null}
      <Field $active={active}>
        <Input
          value={value}
          placeholder={t(placeholder)}
          aria-label={t(label ?? placeholder)}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </Field>
    </Wrap>
  );
};

export default BrandNameInput;